import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  UsersListRequest,
  UsersListResponse,
  User,
  UserCreateRequest,
  UserUpdateRequest,
  UserSetPasswordRequest,
} from "./types";

/**
 * List
 */
export const usersService = (params: UsersListRequest) =>
  RestAPIClient.call<UsersListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });
/**
 * Detail
 */
export const userDetailService = (id: number) =>
  RestAPIClient.call<User>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const userCreateService = (data: UserCreateRequest) =>
  RestAPIClient.call<User>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const userUpdateService = (data: UserUpdateRequest) =>
  RestAPIClient.call<User>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id || ""}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Set Password (Super Admin)
 */
export const userSetPasswordService = (
  id: number,
  data: UserSetPasswordRequest
) =>
  RestAPIClient.call({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.SetPassword}/${id}/set-password`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
